<template>
  <div>
    <payment-summary form-title="Your selection so far" :products='productsSummary' @totalPrice="setTotalPrice"/>
    <credit-card-form v-if="!userHasStaffPaymentTypes" />
    <div class="form-payment" v-else>
      <div class="payment-options" v-if="paymentOptions.length > 1">
        <div class="row">
          <div class="col-md-6">
            <el-button-group class="toggle-options">
              <template v-for="(payment, i) of paymentOptions">
                <el-button
                  :key="i"
                  :type="activePaymentIndex === i ? 'primary' : 'plain'"
                  @click="activePaymentIndex = i"
                  v-if="showPaymentOption(payment)"
                >
                  {{ payment.name }}
                </el-button>
              </template>
            </el-button-group>
          </div>
        </div>
      </div>

      <keep-alive>
        <component :is="paymentOptions[activePaymentIndex].component" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PaymentSummary from '../../components/_FormElements/PaymentSummary.vue';
import CreditCardForm from './PaymentOption/CreditCard.vue';

const SimpleCreditCard = () => import("./PaymentOption/SimpleCreditCard.vue");
const Cash = () => import("./PaymentOption/Cash.vue");
const Cheque = () => import("./PaymentOption/Cheque.vue");

export default {
  components: { PaymentSummary, CreditCardForm },
  data() {
    return {
      activePaymentIndex: 0,
      paymentOptions: [],
      totalPrice: 0,
    };
  },
  computed: {
    ...mapGetters('renewal', ['membershipForm', 'donation', 'availablePaymentForStaff', 'isStaffUser']),
    ...mapGetters('auth', ['userHasStaffPaymentTypes']),
    cashActive()  {
      return Number.parseInt(this.totalPrice) <= 100
    },
    productsSummary() {
      const products = [];

      if (this.membershipForm.previousProducts) {
        products.push(this.membershipForm.previousProducts);
      }

      if (this.membershipForm.standardProducts) {
        products.push(this.membershipForm.standardProducts);
      }

      if (this.membershipForm.secondaryProducts) {
        products.push(this.membershipForm.secondaryProducts);
      }

      if (this.donation.amount > 0) {
        products.push({
          'product-code': 'VOL',
          'product-description': 'Donation',
          'total-price': this.donation.amount
        });
      }

      return products;
    }
  },
  mounted() {
    // if (this.isStaffUser) {
    if (this.userHasStaffPaymentTypes) {
      this.setPaymentOptionsForStaff();
    }
  },
  methods: {
    setPaymentOptionsForStaff() {
      const staffPay = this.availablePaymentForStaff;

      staffPay.forEach(pay => {
        pay = pay.trim();
        switch (pay) {
          case "cash":
            this.paymentOptions.push({
              name: "Cash",
              component: Cash,
              active: true,
            });
            break;
          case "cheque":
            this.paymentOptions.push({
              name: "Cheque",
              component: Cheque,
              active: true,
            });
            break;
          case "simplecreditcard":
            this.paymentOptions.push({
              name: "Credit Card",
              component: SimpleCreditCard,
              active: true,
            });
            break;
          default:
            break;
        }
      });

      // sort to have credit card first item in array
      // (will be auto-selected as activePaymentIndex = 0)
      this.paymentOptions.sort((a, b) => {
        if (a.name === "Credit Card") {
          return -1;
        }
        if (b.name === "Credit Card") {
          return 1;
        }
        return 0;
      });

    },
    setTotalPrice(totalPrice) {
      this.totalPrice = totalPrice;
    },
    showPaymentOption(paymentOption) {

      if (paymentOption.name === "Cash" && !this.cashActive) {
        return false
      }

      return paymentOption.active

    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/fonts/stylesheet.css';

.form-payment {
  margin-top: 20px;

  .payment-options {
    padding: 0 30px;
  }

  .el-button {
    width: 100%;
  }

  .el-button-group {
    display: flex;
  }
}
</style>
